
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Namastestu Mahamaye" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Namastestu Mahamaye" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Namastestu Mahamaye, Mahalakshmi Ashtakam, Lakshmi bhakti, Mahalakshmi blessings, Lakshmi bhakti, namastestu mahamaye lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Namastestu Mahamaye, Mahalakshmi Ashtakam, Divine mother Lakshmi, Goddess Lakshmi prayer, Lakshmi bhakti, Mahalakshmi blessings, Shree Lakshmi Suktam, namastestu mahamaye lyrics, namastestu mahamaye lyrics english, namastestu mahamaye lyrics marathi, namastestu mahamaye, Mahalakshmi Ashtakam with Lyrics' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/mahalakshmi.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/mahalakshmi.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Namastestu Mahamaye | Mahalakshmi Ashtakam - नमस्तेस्तू महामाये(श्री महालक्ष्मी अष्टक)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/mahalakshmi"
        },
        "headline": "Namastestu Mahamaye - नमस्तेस्तू महामाये(श्री महालक्ष्मी अष्टक)",
        "name" : "Namastestu Mahamaye - Mahalakshmi Ashtakam",
        "description": "Explore the full lyrics of stotra 'Namastestu Mahamaye' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/mahalakshmi.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  